import React, { useState, useEffect } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const LineChart = (props) => {
  const [seriesData, setSeriesData] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);
  const [peerData, setPeerData] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);

  // var seriesData = [["experience", 34.9], ["Qualifications", 71.5], ["Courses & Training", 106.4], ["System Expertise", 29.9], ["Compeencies", 71.5], ["Skills", 106.4]];
  const [options, setOptions] = useState({
    chart: {
      backgroundColor: 'transparent',
      spacingBottom: 40,
      height: "250px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      tickInterval: 1,
      gridLineColor: "#eaf5fa",
      gridLineWidth: 15,
      labels: {
        enabled: true,
        style: {
          color: "black", // Set the X-axis text color to white
        },
        useHTML: true,
        formatter: function () {
          return (
            "<span className='graph-label'>" +
            seriesData[this.value][0] +
            "</span>"
          );
        },
      },
    },

       yAxis: {
          title: {
            enabled: false,
          },
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          // plotLines: [
          //   {
          //     color: "black", // Horizontal line color
          //     value: 50, // The value at which the horizontal line will be drawn
          //     width: 2, // Line width
          //     zIndex: 3, // The horizontal line will be drawn above the chart
          //   },
          //   // Add more plotLines as needed ()
          // ],
        },
    legend: {
      enabled: false,
    },

    plotOptions: {
      series: {
        color: "#FF0000",
      },
    },

    series: [
      {
        data: seriesData,
      },
    ],
  });

  useEffect(() => {
    if (props.data !== undefined) {
      setSeriesData(props.data);
      setPeerData(props.data2)

      setOptions({
        chart: {
          spacingBottom: 40,
        },
        title: {
          text: "", // Replace with your desired chart title
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          tickInterval: 1,
          gridLineColor: "#93AEC7",
          gridLineWidth: 15,
          labels: {
            style: {
              fontFamily: "Montserrat, sans-serif",
              color: "black", // Set the X-axis text color to white
            },
            enabled: true,
            useHTML: true,
            rotation: window.innerWidth <= 768 ? -90 : 0, // Rotate only on mobile
            formatter: function () {
              return (
                "<span className='graph-label'>" +
                seriesData[this.value][0] +
                "</span>"
              );
            },
          },
        },

        yAxis: {
          title: {
            enabled: false,
          },
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
        },
        legend: {
          enabled: true,
          align: "right",
          verticalAlign: "top", // Position the legend at the top
          layout: "horizontal",
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          itemStyle: {
            color: "black", // Set the legend text color to white
            display: "inline-block", // Display the legend inline
            fontFamily:'Montserrat, sans-serif	',
            fontWeight: 'normal',
          },
        },
        plotOptions: {
          series: {
            color: "#FF0000",
          },
        },

        series: [
          {
            data: seriesData,
            name: "MY Scores",
            color:'#E95A2C'
          },
          {
            data: peerData,
            color: "#253C75",
            name: "Maximum Available Scores",
          },
        ],
      });
    }
  }, [props, seriesData]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ className: "synopsis-graph" }}
    />
  );
};

export default LineChart;
